type Guid = string;
export default Guid;

export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

export const toNakedGuid = (guid: Guid) => guid.replace(/[{}-]/g, '').toLowerCase();
export const guidEquals = (left: Guid, right: Guid) => toNakedGuid(left) === toNakedGuid(right);

export const isNullOrEmpty = (guid: Guid | null): boolean => {
    if (!guid) {
        return true;
    }

    return !/[^0]/.test(toNakedGuid(guid));
};

export const isGuid = (value: string) => {
    if (!value || value.length < 32) return false;

    const naked = toNakedGuid(value);
    if (!naked) return false;
    return naked.length === 32 && /^[\da-f]+$/i.test(naked);
};

export const newGuid = (): Guid => {
    return [gen(2), gen(1), gen(1), gen(1), gen(3)].join('-');
};

function gen(count: number): string {
    let out = '';

    for (let i = 0; i < count; i++) {
        // tslint:disable-next-line:no-bitwise
        out += (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }

    return out;
}
